import { ErrorHandler, Injectable } from '@angular/core';
import { datadogLogs } from '@datadog/browser-logs';

import { pcgSettings }  from './app/shared/generated/pcg-settings';

@Injectable()
export class DatadogErrorHandler implements ErrorHandler {

    constructor() {}

    // The following are error codes thrown as a result of system security
    // and should not be logged to datadog.
    ignoredErrorCodes: number[] = [
        0 		// Network Error / Aborted Request
        , 401 	// Login redirect
        , 403 	// Access denied
        , 467	// 2fa not enabled
        , 499	// First time Inventory Setup custom redirect
    ];

    handleError(err: any) {
        console.log(err) // Remove this once done debugging datadog error spikes
        if (pcgSettings?.mode?.toLowerCase() === 'development') { console.log(err?.originalError || err); }
        else if (!this.ignoredErrorCodes?.includes(err?.status)) { 
            datadogLogs.logger.error(err?.message, undefined, err); 
        }
    }
}